module.exports = __webpack_public_path__ + "static/media/PP-HERO-EPC.45162225.png";